import stoneService from '@services/magento/stone.service';

import { ShipmentLocation, StoneAttribute, StoneOptions } from '@stone/interfaces';

export async function fetchStoneOptionsApi(): Promise<StoneOptions> {
  return await stoneService.getStoneOptions();
}

export async function fetchWarehouseOptionsApi(): Promise<StoneAttribute[]> {
  return await stoneService.getWarehouseFactories();
}

export async function fetchCarrierOptionsApi(): Promise<StoneAttribute[]> {
  return await stoneService.getCarrierOptions();
}

// Logistic-location lookup used by the shipment flows. Mirrors `fetchPurchaseLocationsApi`
// in the reports slice — same endpoint, opposite `type` filter.
export async function fetchWarehouseLocationsApi(params: any = {}): Promise<ShipmentLocation[]> {
  const response = await stoneService.getStoneLocations(params);
  return (response?.items as ShipmentLocation[]) ?? [];
}
